import { render, staticRenderFns } from "./PinMessage.vue?vue&type=template&id=5299e160"
import script from "./PinMessage.vue?vue&type=script&lang=js"
export * from "./PinMessage.vue?vue&type=script&lang=js"
import style0 from "./PinMessage.vue?vue&type=style&index=0&id=5299e160&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports